import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'creditcard',
  pure: false,
  standalone: true,
})
export class CreditcardPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, '$1 $2 $3 $4');
  }
}
